import { render, staticRenderFns } from "./CustomOrderDetails.vue?vue&type=template&id=d0723562&scoped=true"
import script from "./CustomOrderDetails.vue?vue&type=script&lang=ts"
export * from "./CustomOrderDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0723562",
  null
  
)

export default component.exports